import { withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelAgency } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_agency.css';

export interface ILevelTypeAgencyProps extends Omit<ILevelAgency, 'type'> {
    type?: 'agency';
}

export const withLevelTypeAgency = withBemMod<ILevelTypeAgencyProps, ILevelProps>(
    cnLevel(),
    { type: 'agency' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { images, text, ...otherProps } = props;

        return (
            <BaseLevel {...otherProps}>
                <>
                    <HtmlContent className={cnLevel('text')} content={text} />
                    {images.length > 0 && (
                        <div className={cnLevel('images', { size: images.length })}>
                            {images.map(({ imageSrc, url }) => (
                                <div key={url} className={cnLevel('image')}>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <img src={imageSrc} alt="" />
                                    </a>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            </BaseLevel>
        );
    }
);
